import React, { useState } from 'react';
import { string } from 'prop-types';
import { useUdsCallResponse } from '../hooks/useUdsCallResponse';
import { PromotionCardDataModel } from '../models/PromotionCardDataModel';
import { PromotionProductsMock } from './subcomponents/PromotionProductsMock';
import { PromotionFallback } from './subcomponents/PromotionFallback';

const PromotionCard = (props) => {
  const [isFallbackUI, setIsFallbackUI] = useState(false);
  const thdCustomer = typeof window !== 'undefined' ? window.THDCustomer?.default : null;
  const customerId = thdCustomer?.mcvisID;

  const { data } = useUdsCallResponse(customerId);
  const itemId = data?.uds?.products[0]?.product?.itemId || props?.itemId;
  const onFailBackUI = () => {
    setIsFallbackUI(true);
  };

  if (isFallbackUI) {
    return <PromotionFallback />;
  }

  return (
    <>
      {/* TO-DO: REPLACE THIS WITH PromotionProducts WHEN IT IS UPDATED */}
      <PromotionProductsMock onFail={onFailBackUI} type="card" customerId={itemId} />
    </>
  );
};

PromotionCard.propTypes = {
  itemId: string,
};
PromotionCard.defaultProps = {
  itemId: null,
};
PromotionCard.displayName = 'PromotionCard';

PromotionCard.dataModel = PromotionCardDataModel;

export { PromotionCard };